// extracted by mini-css-extract-plugin
module.exports = {"events__cards":"styles_events__cards__lFL_e","event__list__events":"styles_event__list__events__1nTuI","notification__pagination":"styles_notification__pagination__1Xd8x"};